module.exports = __webpack_public_path__ + "img/services-dttcs-02.6b00d766.svg";